import { ComponentProps, forwardRef, useContext } from 'react'
import { DropdownPrimitives } from '.'
import { DropdownContext } from '../DropdownContext'

export interface Props extends ComponentProps<typeof DropdownPrimitives.Item> {
  icon?: React.ReactElement
}

export const Item = forwardRef<HTMLDivElement, Props>(
  ({ icon, children, onClick, ...rest }: Props, ref) => {
    const { isDarkMode } = useContext(DropdownContext)

    return (
      <DropdownPrimitives.Item
        dark={isDarkMode}
        {...rest}
        onClick={(e) => {
          if (!rest.disabled && onClick) {
            onClick(e)
          }
        }}
        ref={ref}
      >
        <>
          {icon}
          {children}
        </>
      </DropdownPrimitives.Item>
    )
  }
)
